import {
    type StartForgetPasswordResponseType,
    type StartForgetPasswordRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const StartForgetPassword = async (params: StartForgetPasswordRequestType): Promise<StartForgetPasswordResponseType> => {
    return await axios(`${SERVER_ADDRESS}/authentication/startForgetPassword`, {
        method: "POST",
        headers: getHeaders(),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default StartForgetPassword;
